var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"show-more"},[_c('div',{staticClass:"btn show-more__btn",on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.btnLabel))])])}
var staticRenderFns = []

export { render, staticRenderFns }